import { accordionStyles, PURPLE } from "../../styles/shared/accordionStyles";
// src/components/job-details/StageViewAccordionList.jsx
import FigmaIcon from "../icons/FigmaIcon";
import React, { useEffect, useMemo, useState } from "react";
import { stageColor } from "../../utils/pipelineStages";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
  TablePagination } from "@mui/material";

export function AccordionHeadingIcon({ stage = "" }) {
  const color = stageColor(stage);
  const normalizedStage = String(stage).trim().toLowerCase();
  if (normalizedStage === "matched") {
    return (
      <svg data-stage-icon="matched" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M20.6196 13.07C20.2396 13.07 19.9196 12.78 19.8696 12.4C19.6296 10.14 18.4096 8.09001 16.5296 6.79001C16.1896 6.55001 16.1096 6.09001 16.3396 5.75001C16.5796 5.41001 17.0496 5.33001 17.3796 5.56001C19.6196 7.11001 21.0596 9.55001 21.3496 12.24C21.3896 12.65 21.0996 13.02 20.6796 13.07C20.6696 13.07 20.6396 13.07 20.6196 13.07Z" fill={color} />
        <path d="M3.48991 13.12C3.45991 13.12 3.43991 13.12 3.40991 13.12C2.99991 13.07 2.69991 12.7 2.73991 12.29C3.00991 9.60001 4.43991 7.17001 6.64991 5.60001C6.98991 5.36001 7.4599 5.44001 7.6999 5.78001C7.9399 6.12001 7.8599 6.59001 7.51991 6.83001C5.65991 8.14001 4.45991 10.19 4.22991 12.45C4.19991 12.83 3.86991 13.12 3.48991 13.12Z" fill={color} />
        <path d="M12.06 22.61C10.58 22.61 9.16997 22.27 7.84997 21.61C7.47997 21.42 7.32997 20.97 7.51997 20.6C7.70997 20.23 8.15997 20.08 8.52997 20.27C10.69 21.36 13.29 21.38 15.47 20.33C15.84 20.15 16.29 20.31 16.47 20.68C16.65 21.05 16.49 21.5 16.12 21.68C14.84 22.3 13.48 22.61 12.06 22.61Z" fill={color} />
        <path d="M12.0603 8.44001C10.1103 8.44001 8.53027 6.86001 8.53027 4.91001C8.53027 2.96 10.1103 1.38 12.0603 1.38C14.0103 1.38 15.5903 2.96 15.5903 4.91001C15.5903 6.86001 14.0003 8.44001 12.0603 8.44001ZM12.0603 2.89001C10.9403 2.89001 10.0303 3.80001 10.0303 4.92001C10.0303 6.04001 10.9403 6.95001 12.0603 6.95001C13.1803 6.95001 14.0903 6.04001 14.0903 4.92001C14.0903 3.80001 13.1703 2.89001 12.0603 2.89001Z" fill={color} />
        <path d="M4.82981 20.67C2.8798 20.67 1.2998 19.09 1.2998 17.14C1.2998 15.2 2.8798 13.61 4.82981 13.61C6.77981 13.61 8.35981 15.19 8.35981 17.14C8.35981 19.08 6.77981 20.67 4.82981 20.67ZM4.82981 15.11C3.70981 15.11 2.7998 16.02 2.7998 17.14C2.7998 18.26 3.70981 19.17 4.82981 19.17C5.94981 19.17 6.85981 18.26 6.85981 17.14C6.85981 16.02 5.94981 15.11 4.82981 15.11Z" fill={color} />
        <path d="M19.1696 20.67C17.2196 20.67 15.6396 19.09 15.6396 17.14C15.6396 15.2 17.2196 13.61 19.1696 13.61C21.1196 13.61 22.6996 15.19 22.6996 17.14C22.6896 19.08 21.1096 20.67 19.1696 20.67ZM19.1696 15.11C18.0496 15.11 17.1396 16.02 17.1396 17.14C17.1396 18.26 18.0496 19.17 19.1696 19.17C20.2896 19.17 21.1996 18.26 21.1996 17.14C21.1896 16.02 20.2896 15.11 19.1696 15.11Z" fill={color} />
      </svg>
    );
  }
  const common = {
    stroke: color,
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke" };
  let graphic;

  // These are the small outlined workflow icons used in the stage reference.
  // Keep the artwork inside a 24px box while the strokes remain a true 1px.
  switch (normalizedStage) {
    case "applied":
      graphic = <><rect x="7" y="8" width="10" height="9" rx="1.5" {...common} /><path d="M10 8V6.5h4V8M7 11h10M11 12.5h2" {...common} /></>;
      break;
    case "sourced":
      graphic = <><circle cx="10.25" cy="10" r="3.25" {...common} /><path d="m12.7 12.45 4.05 4.05M5.75 17.5c.7-2.1 2.1-3.15 4.5-3.15" {...common} /></>;
      break;
    case "contacted":
      graphic = <><rect x="5.5" y="7.25" width="13" height="9.5" rx="1.5" {...common} /><path d="m6.5 8.25 5.5 4.2 5.5-4.2" {...common} /></>;
      break;
    case "screened":
      graphic = <><path d="M6 7.5h9.5A1.5 1.5 0 0 1 17 9v5a1.5 1.5 0 0 1-1.5 1.5H10l-3.5 2v-2H6A1.5 1.5 0 0 1 4.5 14V9A1.5 1.5 0 0 1 6 7.5Z" {...common} /><path d="M9 11.5h4.5M9 13.5h3" {...common} /></>;
      break;
    case "interview":
    case "interviewing":
      graphic = <><rect x="5.5" y="6.5" width="13" height="9" rx="1.5" {...common} /><path d="M9.5 18h5M12 15.5V18M10 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM8.75 13.5c.6-1.2 1.7-1.8 3.25-1.8s2.65.6 3.25 1.8" {...common} /></>;
      break;
    case "assessment":
      graphic = <><rect x="7" y="5.5" width="10" height="13" rx="1.5" {...common} /><path d="M10 5.5h4v2h-4zM9.5 11h5M9.5 14h3M14.5 14l.9.9 1.6-1.8" {...common} /></>;
      break;
    case "offer":
      graphic = <><path d="M6 8.25h12v8.5H6zM6 10.5h12M9 13.25h2.25M14.5 13.25h.01" {...common} /><path d="M8.5 6.5h7" {...common} /></>;
      break;
    case "hired":
      graphic = <><circle cx="9" cy="10" r="2.25" {...common} /><circle cx="15.5" cy="10.5" r="1.75" {...common} /><path d="M5.5 17.25c.6-2.25 1.8-3.4 3.5-3.4s2.9 1.15 3.5 3.4M13.1 14.4c1.85.05 3.05 1 3.65 2.85" {...common} /></>;
      break;
    case "rejected":
      graphic = <><rect x="6.5" y="6.5" width="11" height="11" rx="1.5" {...common} /><path d="m9.5 9.5 5 5M14.5 9.5l-5 5" {...common} /></>;
      break;
    case "presented":
      graphic = <><path d="M7 6.5h10v11H7zM9.5 10h5M9.5 13h3.5" {...common} /><path d="M10 18.5h4" {...common} /></>;
      break;
    default:
      graphic = <><circle cx="12" cy="10" r="3" {...common} /><path d="M6.75 18c1.25-2.5 3-3.75 5.25-3.75S16 15.5 17.25 18" {...common} /></>;
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <g transform="translate(-4.8 -4.8) scale(1.4)">{graphic}</g>
    </svg>
  );
}

/* -------------------- header icons (match your screenshot) -------------------- */
function IconGrid2x2({ size = 18, color = PURPLE }) {
  return <FigmaIcon name="grid" size={size} color={color} />;
}

function IconChecklist({ size = 18, color = PURPLE }) {
  return <FigmaIcon name="list" size={size} color={color} />;
}

function IconChevronDown({ size = 18, color = PURPLE }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7 10l5 5 5-5" stroke={color} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function HeaderIconBtn({ title, onClick, active = false, children }) {
  return (
    <Tooltip title={title} arrow>
      <IconButton
        size="small"
        onClick={onClick}
        sx={accordionStyles.viewButton({ active })}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}

/* -------------------- safe renderer caller (fixes your crash) -------------------- */
function callRendererSafely(renderer, itemsArray, stageKey) {
  if (typeof renderer !== "function") return null;

  // Always ensure array
  const safeItems = Array.isArray(itemsArray) ? itemsArray : [];

  // Support BOTH signatures:
  // 1) renderer(items, stageKey)
  // 2) renderer({ items, stageKey })
  try {
    return renderer(safeItems, stageKey);
  } catch (e1) {
    try {
      return renderer({ items: safeItems, stageKey });
    } catch (e2) {
      // If the user renderer still fails, don't crash the whole page
      return null;
    }
  }
}

/* -------------------- a single accordion row -------------------- */
function StageViewAccordion({
  stageKey,
  icon,
  count,
  expanded,
  onToggle,
  items,
  isLast,
  view,
  onSetView,
  renderGrid,
  renderList,
  renderHistory,
  emptyText = "No candidates yet.",
  pageSize = 0,
  pageResetKey }) {
  const safeItems = Array.isArray(items) ? items : [];
  const [page, setPage] = useState(0);
  useEffect(() => { setPage(0); }, [pageResetKey, pageSize]);
  const currentPage = pageSize ? Math.min(page, Math.max(0, Math.ceil(safeItems.length / pageSize) - 1)) : 0;
  const visibleItems = pageSize ? safeItems.slice(currentPage * pageSize, (currentPage + 1) * pageSize) : safeItems;
  const headingColor = stageColor(stageKey);
  const isGrid = view === "grid";
  const isList = view === "list";

  return (
    <Accordion
      disableGutters
      elevation={0}
      expanded={expanded}
      onChange={() => onToggle(stageKey)}
      sx={accordionStyles.root({ isLast })}
    >
      <AccordionSummary
        component={pageSize ? "div" : undefined}
        expandIcon={null}
        sx={accordionStyles.summary()}
      >
        {/* left */}
        <Box sx={accordionStyles.headingRow()}>
          <Box
            sx={accordionStyles.headingIcon({ headingColor })}
          >
            {icon}
          </Box>

          <Typography sx={accordionStyles.heading({ headingColor })} noWrap>
            {stageKey}
          </Typography>

          <Typography component={pageSize ? "button" : "span"} type={pageSize ? "button" : undefined}
            aria-label={pageSize ? `View ${count} ${stageKey} in list` : undefined}
            onClick={pageSize ? event => { event.stopPropagation(); setPage(0); onSetView(stageKey, "list"); if (!expanded) onToggle(stageKey); } : undefined}
            onKeyDown={pageSize ? event => event.stopPropagation() : undefined}
            sx={accordionStyles.count({ headingColor, pageSize })} noWrap>
            ({count})
          </Typography>
        </Box>

        <Box sx={accordionStyles.spacer()} />

        {/* right: grid | list | divider | chevron */}
        <Box sx={accordionStyles.controls()}>
          {/* stop accordion toggle only for view buttons */}
          <Box onClick={(e) => e.stopPropagation()} sx={accordionStyles.viewControls()}>
            <HeaderIconBtn title="Grid view" active={isGrid} onClick={() => onSetView(stageKey, "grid")}>
              <IconGrid2x2 size={18} />
            </HeaderIconBtn>

            <HeaderIconBtn title="List view" active={isList} onClick={() => onSetView(stageKey, "list")}>
              <IconChecklist size={18} />
            </HeaderIconBtn>
          </Box>

          {/* vertical divider */}
          <Box sx={accordionStyles.divider()} />

          {/* chevron toggles accordion */}
          <IconButton
            size="small"
            sx={accordionStyles.toggle({ expanded })}
            aria-label={expanded ? "Collapse" : "Expand"}
          >
            <IconChevronDown size={18} />
          </IconButton>
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={accordionStyles.details()}>
        {expanded && renderHistory?.(stageKey)}
        {safeItems.length ? (
          isGrid ? (
            callRendererSafely(renderGrid, visibleItems, stageKey) || (
              <Typography sx={accordionStyles.missingGrid()}>
                Grid renderer not provided.
              </Typography>
            )
          ) : (
            callRendererSafely(renderList, visibleItems, stageKey) || (
              <Typography sx={accordionStyles.missingList()}>
                List renderer not provided.
              </Typography>
            )
          )
        ) : (
          <Typography sx={accordionStyles.emptyState()}>
            {emptyText}
          </Typography>
        )}
        {pageSize > 0 && safeItems.length > pageSize && <TablePagination component="div" count={safeItems.length} page={currentPage} rowsPerPage={pageSize} rowsPerPageOptions={[pageSize]} onPageChange={(_, nextPage) => setPage(nextPage)} sx={accordionStyles.pagination()} />}
      </AccordionDetails>
    </Accordion>
  );
}

/* -------------------- reusable accordion list -------------------- */
export default function StageViewAccordionList({
  pageSize = 0,
  pageResetKey,
  stages = [], // [{ key, icon, items }]
  defaultExpanded = {},
  defaultView = "grid", // "grid" | "list"
  emptyText = "No candidates yet.",
  renderGrid, // supports (items, stageKey) OR ({items, stageKey})
  renderList, // supports (items, stageKey) OR ({items, stageKey})
  renderHistory }) {
  const stageKeys = useMemo(() => (Array.isArray(stages) ? stages.map((s) => s.key) : []), [stages]);

  const [expanded, setExpanded] = useState(() => {
    const init = {};
    stageKeys.forEach((k) => (init[k] = defaultExpanded[k] ?? true));
    return init;
  });

  const [stageView, setStageView] = useState(() => {
    const init = {};
    stageKeys.forEach((k) => (init[k] = defaultView));
    return init;
  });

  useEffect(() => {
    setExpanded((prev) => {
      const next = {};
      stageKeys.forEach((key) => {
        next[key] =
          Object.prototype.hasOwnProperty.call(prev, key)
            ? prev[key]
            : defaultExpanded[key] ?? true;
      });

      const prevKeys = Object.keys(prev);
      const changed =
        prevKeys.length !== stageKeys.length ||
        stageKeys.some((key) => !Object.prototype.hasOwnProperty.call(prev, key));

      return changed ? next : prev;
    });
  }, [defaultExpanded, stageKeys]);

  useEffect(() => {
    setStageView((prev) => {
      const next = {};
      stageKeys.forEach((key) => {
        next[key] = prev[key] || defaultView;
      });

      const prevKeys = Object.keys(prev);
      const changed =
        prevKeys.length !== stageKeys.length ||
        stageKeys.some((key) => !Object.prototype.hasOwnProperty.call(prev, key));

      return changed ? next : prev;
    });
  }, [defaultView, stageKeys]);

  const toggle = (key) => setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));
  const setView = (key, view) => setStageView((prev) => ({ ...prev, [key]: view }));

  return (
    <Box sx={accordionStyles.list()}>
      {stages.map((s, idx) => {
        const isLast = idx === stages.length - 1;
        const items = Array.isArray(s.items) ? s.items : [];

        return (
          <StageViewAccordion
            key={s.key}
            stageKey={s.key}
            icon={s.icon}
            count={items.length}
            pageSize={pageSize}
            pageResetKey={pageResetKey}
            expanded={!!expanded[s.key]}
            onToggle={toggle}
            items={items}
            isLast={isLast}
            view={stageView[s.key] || defaultView}
            onSetView={setView}
            renderGrid={renderGrid}
            renderList={renderList}
            renderHistory={renderHistory}
            emptyText={emptyText}
          />
        );
      })}
    </Box>
  );
}
